module.exports = __webpack_public_path__ + "img/core-first-1.07a8afda.png";